@if (service.items().length) {
    <div class="label-switcher-menu flexbox flex-column" [ngClass]="{ 'single-page-mode': accountMenuDataService.singlePageMode }">
        <ds-radio-group size="large" labelPosition="left" [value]="service.currentLabelItem()?.name ?? ''">
            @for (item of service.items(); track trackByName($index, item)) {
                <div class="form-element form-element-right">
                    <ds-radio-button [value]="item.name" name="options" [checked]="item.isActive" (change)="switchLabel(item)">
                        {{ item.text }}</ds-radio-button
                    >
                </div>
            }
        </ds-radio-group>
    </div>
}
